export var getWidthPlusMargin = function getWidthPlusMargin(element) {
  var _global$getComputedSt = global.getComputedStyle(element),
      marginLeft = _global$getComputedSt.marginLeft,
      marginRight = _global$getComputedSt.marginRight;

  return element.clientWidth + parseInt(marginLeft) + parseInt(marginRight);
};